import React, { ReactNode, ReactElement } from 'react';

import { theme as defaultTheme } from '@lucid/theme';
import { useSiteMetadata } from '@lucid/utils';
// import { render, RenderOptions } from '@testing-library/react';
// import userEvent from '@testing-library/user-event';

import { ThemeProvider } from '../theme-provider/theme-provider';
import { LucidThemeType, Products } from '../../types/types';

export interface ThemeHelperProps {
  /** The rendered children with the correct theme. */
  children: ReactNode;
  /** The theme object. */
  theme?: LucidThemeType.Props['theme'];
  /** The available sites to set proper theme values. */
  product?: Products.Site;
}

const ThemeHelper = ({ children, theme = defaultTheme, product }: ThemeHelperProps): ReactElement => {
  const { product: siteProduct } = useSiteMetadata();
  const currentSiteProduct = product || siteProduct || 'chart';

  return (
    <ThemeProvider
      key={`@lucid/components-react-theme-helper-${currentSiteProduct}`}
      product={currentSiteProduct}
      theme={theme}
    >
      {children}
    </ThemeProvider>
  );
};

// const themeHelperRender = (ui: ReactElement, options?: RenderOptions) =>
//   render(ui, {
//     wrapper: ThemeHelper as ComponentType<{ children: ReactElement }>,
//     ...options
//   });

// eslint-disable-next-line import/export
// export * from '@testing-library/react';

// eslint-disable-next-line import/export
// export { themeHelperRender as render, userEvent };

export default ThemeHelper;
